import {
  AgxSlideUpModal,
  CampaignDetailModel,
} from '@urbanx/agx-ui-components';
import { Tabs } from 'types/Tabs';
import CampaignInfoPanel from '../../CampaignInfoPanel/CampaignInfoPanel';

interface SelectedCampaignModalProps {
  selectedCampaign?: CampaignDetailModel;
  currentTab: Tabs;
  onClosed: () => void;
}

export const SelectedCampaignModal = ({
  selectedCampaign,
  currentTab,
  onClosed,
}: SelectedCampaignModalProps) => {
  if (selectedCampaign == null) return null;

  return (
    <AgxSlideUpModal
      content={
        <CampaignInfoPanel
          campaign={selectedCampaign}
          currentTab={currentTab}
          mobile
        />
      }
      onClose={onClosed}
      closeButton
      useFullHeight
    />
  );
};
